<template>
  <container-slot>
    <v-col cols="12">
      <h1 class="display-1 font-weight-medium">
        Change Password {{ `"${userName}"` }}
      </h1>
    </v-col>
    <v-col cols="12" v-show="successSubmit">
      <v-alert
        :type="!error ? `success` : `error`"
        ref="alert"
        dismissible
        @input="close"
        class="noMarg"
        v-show="successSubmit"
      >
        {{ msg }}
      </v-alert>
    </v-col>
    <v-col cols="12" md="4">
      <v-form ref="form" v-model="valid" @submit="submitForm">
        <v-text-field
          prepend-inner-icon="mdi-account-lock"
          name="password"
          label="Password"
          type="password"
          v-model="password"
          :rules="passwordRules"
          ref="passwordInput"
          outlined
          required
        >
        </v-text-field>
        <v-text-field
          prepend-inner-icon="mdi-account-lock"
          name="passwordConfirmation"
          label="Password Confirmation"
          type="password"
          v-model="passwordConfirmation"
          :rules="passwordConfirmationRules"
          ref="passwordConfirmationInput"
          outlined
          required
        >
        </v-text-field>
        <v-btn
          :disabled="!valid"
          color="primary"
          @click="submitForm"
          ref="submitBtn"
          :loading="loading"
        >
          Submit
        </v-btn>
      </v-form>
    </v-col>
  </container-slot>
</template>

<script>
import ContainerSlot from "@/components/ContainerSlot";
import { getUserById } from "@/utils/graphqlQuery";
import { editUser } from "@/utils/graphqlMutation";
import { lsUtils } from "@/utils/localStorageUtils";

const { id: currentUserId } = lsUtils.getItem("userToken").userData;

export default {
  apollo: {
    userData: {
      query: getUserById,
      update: function (data) {
        if (!data.getUserById) {
          this.$router.replace({ path: "/user/edit" });
        } else {
          this.userName = data.getUserById.userName;
          return data.getUserById;
        }
      },
      variables() {
        return {
          userId: this.userId,
        };
      },
    },
  },
  components: {
    ContainerSlot,
  },
  data() {
    return {
      error: false,
      msg: "",
      loading: false,
      password: "",
      passwordRules: [
        (v) => !!v || "Password is required",
        (v) => v.length > 8 || "Password must be greater than 8 characters",
      ],
      passwordConfirmation: "",
      passwordConfirmationRules: [
        (v) => !!v || "Password Confirmation is required",
        (v) =>
          v === this.password ||
          "Password Confirmation must be same as Password",
      ],
      successSubmit: false,
      userData: {},
      userId: this.$route.params.userId,
      userName: "",
      valid: false,
    };
  },
  methods: {
    close() {
      this.successSubmit = false;
      this.msg = "";
      this.error = false;
    },
    async submitForm(e) {
      e.preventDefault();
      this.successSubmit = false;
      if (this.valid) {
        this.loading = true;
        try {
          const userObj = {
            id: this.userId,
            password: this.password,
            isActive: 1,
          };
          const { data } = await this.$apollo.mutate({
            mutation: editUser,
            variables: {
              userObj,
            },
          });

          if (data.editUser) {
            const { success, msg } = data.editUser;
            if (success == 0) {
              throw new Error(msg);
            } else if (success == -1) {
              this.error = true;
              this.info = true;
              this.msg = "No changes has made";
            } else {
              this.error = false;
              this.msg = msg;
              if (currentUserId == this.userId) {
                setTimeout(async () => {
                  lsUtils.removeItem("userToken");
                  this.loading = false;
                  await this.$apollo.provider.defaultClient.clearStore();
                  this.$router.push("/login?redir=1");
                }, 1000);
              }
            }
          } else {
            this.error = true;
            this.msg = `Something went wrong`;
          }
        } catch (error) {
          this.error = true;
          this.msg = error.message;
        } finally {
          this.successSubmit = true;
          this.loading = false;
        }
      }
    },
  },
  name: "ChangePassword",
  title() {
    return "Change Password";
  },
};
</script>

<style></style>
